<template>
    <div v-if="config">
        <v-label>Pingdom IDs</v-label>
        <div style="margin-top:5px">
            <v-chip v-for="(id, i) in config.checkIds"
                    :key="id"
                    @click:close="remove(i)"
                    class="mr-2 mb-2"
                    close label
            >
                {{ id }}
            </v-chip>
        </div>

        <v-row>
            <v-col cols="12">
                <v-input>
                    <v-text-field v-model="checkId" label="Add Pingdom ID" />
                    <v-btn color="primary" @click="add()" icon>
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-input>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: ["config"],
    data: () => ({
        checkId: null
    }),
    methods: {
        remove(i) {
            this.config.checkIds.splice(i, 1);
        },
        clear() {
            this.checkId = null;
        },
        add() {
            this.config.checkIds = this.config.checkIds || [];

            if (!this.checkId || !this.checkId.match(/\d+/))
                return;

            this.config.checkIds.push(parseInt(this.checkId));

            this.clear();
        }
    }
};
</script>